import React from "react";
import ReportingLinks from "./ReportingLinks";
import PageHeader from "../Common/PageHeader";
import ReportsIcon from "../../assets/icons/icon_reports-01.svg2";
import WidgetContainer from "../Common/WidgetContainer";

const defaultWidgetLayout = [
  { i: "./MessagingWidget.jsx", x: 0, y: 0, w: 5, h: 15 },
  { i: "./WorkflowsWidget.jsx", x: 5, y: 0, w: 5, h: 15 },
  { i: "./FeaturesWidget.jsx", x: 10, y: 0, w: 5, h: 15 },
  { i: "./FinancialWidget.jsx", x: 15, y: 0, w: 5, h: 15 },
];

export default function ReportingLandingPage() {
  return (
    <div>
      <PageHeader
        Icon={ReportsIcon}
        heading="Reports"
        subheading="Access quick reports on your activity"
      />
      <ReportingLinks />
      <WidgetContainer
        defaultLayout={defaultWidgetLayout}
        lsField="reportingWidgetLayout"
      />
    </div>
  );
}
